import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, CircularProgress } from '@mui/material';
import { toast, Toaster } from 'sonner';
import GetAppIcon from '@mui/icons-material/GetApp';
import axios from 'axios';


const InvoiceHistory = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  const userIdFromRedux = useSelector(state => state.onboarding.userId);
  const userId = userIdFromRedux || localStorage.getItem('userId');

  useEffect(() => {
    fetchInvoices();
  }, [userId]);

  const fetchInvoices = async () => {
    if (!userId) {
      toast.error('User ID not available');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.get(`https://aitaler-backend-production.devops-565.workers.dev/api/invoices?userId=${userId}`);
      if (Array.isArray(response.data)) {
        setInvoices(response.data);
      } else {
        console.error('Unexpected response format:', response.data);
        toast.error('Unexpected response format from server');
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
        console.error('Error status:', error.response.status);
        console.error('Error headers:', error.response.headers);
      } else if (error.request) {
        console.error('Error request:', error.request);
        console.error('Error request config:', error.config);
      } else {
        console.error('Error message:', error.message);
      }
      toast.error(`Error fetching invoices: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (invoiceId) => {
    if (!userId) {
      toast.error('User ID not available');
      return;
    }
    if (!invoiceId) {
      toast.error('Invoice ID is missing');
      return;
    }

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/invoices/download?userId=${userId}&invoiceId=${invoiceId}`, {
        responseType: 'blob', // Important for handling PDF files
      });

      // Create a blob from the response data
      const blob = new Blob([response.data], { type: 'application/pdf' });
      
      // Create a link element and trigger the download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `invoice_${invoiceId}.pdf`;
      link.click();

      // Clean up
      window.URL.revokeObjectURL(link.href);
      toast.success('Invoice downloaded successfully');
    } catch (error) {
      console.error('Error downloading invoice:', error);
      toast.error(`Error downloading invoice: ${error.message}`);
    }
  };


  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Invoice History</Typography>
      {invoices.length === 0 ? (
        <Typography>No invoices found.</Typography>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoices.map((invoice) => {
                return (
                  <TableRow key={invoice.invoiceId}>
                    <TableCell>{invoice.month}</TableCell>
                    <TableCell>{invoice.amount}</TableCell>
                    <TableCell>{invoice.status || 'N/A'}</TableCell>
                    <TableCell>
                      <Button
                        startIcon={<GetAppIcon />}
                        onClick={() => {
                          handleDownload(invoice.invoiceId);
                        }}
                      >
                        Download
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Toaster position="top-right" className='mt-24' expand={false} richColors />
    </Paper>
  );
};

export default InvoiceHistory;
